import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

type Props = { language?: string }

export const useUpdateTranslations = ({ language }: Props) => {
  const { i18n } = useTranslation()

  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language)
    }
  }, [language, i18n])
}
